import {useIssueCreateDataContext} from '../contexts/IssueCreateDataContext'
import {useIssueCreateConfigContext} from '../contexts/IssueCreateConfigContext'
import {MetadataFooter} from './MetadataFooter'
import {MetadataSidebar} from './MetadataSidebar'

export type SharedMetadataProps = {
  repo: string
  owner: string
  canAssign: boolean
  canLabel: boolean
  canMilestone: boolean
  canProject: boolean
  canType: boolean
  canSetIssueFields: boolean
  issueTypesEnabled: boolean
}

export const MetadataSelectors = () => {
  const {optionConfig} = useIssueCreateConfigContext()
  const showMetadataInSidebar = !optionConfig.insidePortal
  const {repository} = useIssueCreateDataContext()

  const canAssign = repository?.viewerIssueCreationPermissions?.assignable
  const canLabel = repository?.viewerIssueCreationPermissions?.labelable
  const canMilestone = repository?.viewerIssueCreationPermissions?.milestoneable
  const canProject = repository?.viewerIssueCreationPermissions?.triageable
  const canType = repository?.viewerIssueCreationPermissions?.typeable
  const canSetIssueFields = repository?.viewerIssueCreationPermissions?.canSetIssueFields
  const issueTypesEnabled = repository?.owner?.issueTypesEnabled

  const sharedMetadataProps: SharedMetadataProps = {
    repo: repository?.name || '',
    owner: repository?.owner.login || '',
    canAssign: canAssign ?? false,
    canLabel: canLabel ?? false,
    canMilestone: canMilestone ?? false,
    canProject: canProject ?? false,
    canType: canType ?? false,
    canSetIssueFields: canSetIssueFields ?? false,
    issueTypesEnabled: issueTypesEnabled ?? false,
  }

  return showMetadataInSidebar ? (
    <MetadataSidebar {...sharedMetadataProps} />
  ) : (
    <MetadataFooter {...sharedMetadataProps} />
  )
}

try{ MetadataSelectors.displayName ||= 'MetadataSelectors' } catch {}